// Normalise une chaîne pour une comparaison insensible à la casse et aux
// accents — sans ça, rechercher "melissa" ne retrouve pas un utilisateur nommé
// "Mélissa". Décompose les caractères accentués (NFD) puis retire les
// marques diacritiques combinantes qui en résultent.
export function normalizeText(value) {
  return (value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}
